const getFiltersQueryString = (state) => state.selectedFilters.query;

const getFilters = (state) => state.selectedFilters;

export { getFiltersQueryString, getFilters };
